import { handleActions } from 'redux-actions';
import { NotificationManager } from "react-notifications";
import { initialize as initializeForm } from 'redux-form';
import { api } from "api";


let url = 'tax-credit';
let urlAnnual = 'annual-tax-credit';
let form = 'RecipeModal';
// ------------------------------------
// Constants
// ------------------------------------

export const constants = {
    LOADER: 'LOADER_TAX_CREDITD',
    DATA: 'DATA_TAX_CREDIT',
    PAGE: 'PAGE_TAX_CREDIT',
    ORDERING: 'ORDERING',
    SEARCH: 'SEARCH',
    DATA_MODAL: 'DATA_MODAL_TAX_CREDIT',
    TAB_EN_CURSO: 'TAB_EN_CURSO_TAX_CREDIT',
}
// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});
const setData = data => ({
    type: constants.DATA,
    data,
});
const setDataModal = data_modal => ({
    type: constants.DATA_MODAL,
    data_modal,
});


// -----------------------------------
// Actions
// -----------------------------------

const initializeEmptyForm = (formName) => (dispatch) => {
    dispatch(initializeForm(formName, {}));
    dispatch(setDataModal({}));

};

const read = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${url}/get_budget_tax_credit`)
        .then((response) => {
            const { results } = response;
            dispatch(initializeForm(form, results));
            dispatch(setData(response));
        })
        .catch((error) => {
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};
const readAnnual = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${urlAnnual}/get_budget_tax_credit`)
        .then((response) => {
            const { results } = response;
            dispatch(initializeForm(form, results));
            dispatch(setData(response));
        })
        .catch((error) => {
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getVatDragConfig = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${url}/get_vat_drag`).then((response) => {
        dispatch(setDataModal(response));
        dispatch(initializeForm('VatDragForm', response.results));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const editarModal = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${url}/${id}`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};




const setTab = (tab) => (dispatch) => {
    dispatch(setLoader(true));
    dispatch({ type: constants.TAB_EN_CURSO, tab });
};

export const actions = {
    read,
    setTab,
    initializeEmptyForm,
    getVatDragConfig,
    editarModal,
    readAnnual
};

// -----------------------------------
// Reducers
// -----------------------------------

const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },

    [constants.DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },

    [constants.ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },

    [constants.DATA_MODAL]: (state, { data_modal }) => {
        return {
            ...state,
            data_modal,
        };
    },
    [constants.TAB_EN_CURSO]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },

};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    data_modal: {},
    item: {},
    tab : 'EN_CURSO'

};
export default handleActions(reducers, initialState);